const bank = {
    en: {
        "bank.title": "Bank reconciliation",
        "bank.upload": "Upload statement (CSV)",
        "bank.uploadHint": "CSV with date, amount and description columns",
        "bank.uploading": "Reconciling…",
        "bank.statements": "Statements",
        "bank.filename": "File",
        "bank.lines": "Lines",
        "bank.matched": "Matched",
        "bank.unmatched": "Unmatched",
        "bank.ignored": "Ignored",
        "bank.total": "Total",
        "bank.uploadedBy": "Uploaded by",
        "bank.uploadedAt": "Date",
        "bank.open": "Open",
        "bank.delete": "Delete",
        "bank.none": "No statements yet",
        "bank.back": "Back to statements",
        "bank.date": "Date",
        "bank.amount": "Amount",
        "bank.description": "Description",
        "bank.status": "Status",
        "bank.match": "Match",
        "bank.matchedTxn": "Matched transaction",
        "bank.selectTxn": "Select transaction…",
        "bank.markIgnored": "Ignore",
        "bank.unmatch": "Unmatch",
        "bank.confirmDelete": "Delete this statement?",
        "bank.summaryMatched": "Matched",
        "bank.summaryUnmatched": "Unmatched",
        "bank.summaryTotal": "Statement total",
    },
    ru: {
        "bank.title": "Сверка с банком",
        "bank.upload": "Загрузить выписку (CSV)",
        "bank.uploadHint": "CSV со столбцами дата, сумма и описание",
        "bank.uploading": "Сверка…",
        "bank.statements": "Выписки",
        "bank.filename": "Файл",
        "bank.lines": "Строки",
        "bank.matched": "Сопоставлено",
        "bank.unmatched": "Не сопоставлено",
        "bank.ignored": "Игнорировано",
        "bank.total": "Итого",
        "bank.uploadedBy": "Загрузил",
        "bank.uploadedAt": "Дата",
        "bank.open": "Открыть",
        "bank.delete": "Удалить",
        "bank.none": "Выписок пока нет",
        "bank.back": "К выпискам",
        "bank.date": "Дата",
        "bank.amount": "Сумма",
        "bank.description": "Описание",
        "bank.status": "Статус",
        "bank.match": "Сопоставить",
        "bank.matchedTxn": "Сопоставленная транзакция",
        "bank.selectTxn": "Выберите транзакцию…",
        "bank.markIgnored": "Игнорировать",
        "bank.unmatch": "Отменить сопоставление",
        "bank.confirmDelete": "Удалить эту выписку?",
        "bank.summaryMatched": "Сопоставлено",
        "bank.summaryUnmatched": "Не сопоставлено",
        "bank.summaryTotal": "Итого по выписке",
    },
    geo: {
        "bank.title": "ბანკის ამონაწერის შედარება",
        "bank.upload": "ამონაწერის ატვირთვა (CSV)",
        "bank.uploadHint": "CSV სვეტებით: თარიღი, თანხა, აღწერა",
        "bank.uploading": "მიმდინარეობს შედარება…",
        "bank.statements": "ამონაწერები",
        "bank.filename": "ფაილი",
        "bank.lines": "ხაზები",
        "bank.matched": "დამთხვეული",
        "bank.unmatched": "დაუმთხვეველი",
        "bank.ignored": "იგნორირებული",
        "bank.total": "სულ",
        "bank.uploadedBy": "ატვირთა",
        "bank.uploadedAt": "თარიღი",
        "bank.open": "გახსნა",
        "bank.delete": "წაშლა",
        "bank.none": "ამონაწერები ჯერ არ არის",
        "bank.back": "ამონაწერებზე დაბრუნება",
        "bank.date": "თარიღი",
        "bank.amount": "თანხა",
        "bank.description": "აღწერა",
        "bank.status": "სტატუსი",
        "bank.match": "დამთხვევა",
        "bank.matchedTxn": "დამთხვეული ტრანზაქცია",
        "bank.selectTxn": "აირჩიეთ ტრანზაქცია…",
        "bank.markIgnored": "იგნორი",
        "bank.unmatch": "დამთხვევის გაუქმება",
        "bank.confirmDelete": "წავშალო ეს ამონაწერი?",
        "bank.summaryMatched": "დამთხვეული",
        "bank.summaryUnmatched": "დაუმთხვეველი",
        "bank.summaryTotal": "ამონაწერის ჯამი",
    },
};

export default bank;
